module.exports = __webpack_public_path__ + "tile-4-image-tTPK2Zq.webp";